// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"8c7f5d9991d3ec75fec8","453":"e4f8e99b92c8a688907d","522":"135b2ebea742420cd860","945":"71a97514c3d6aaad05d6"}[chunkId] + ".js";
};